module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgB1VJbEcMgEEQCEpBQCUjAQeKgcZA4aBykDiIhEirhJETCFdql2WHymn61N7MzwC17T2P+0lS10bfNEVNEtUduIx4RAnIgn4/oAYHobUtEITCAnKJb+C3EHO4d+E0pNKbPdL+A2BWlJWvxdudgZQ88vaUyp6K8nIkHktUsZKHe0yddayp4A86frJnQ51SRtpoVgy9Q8KokuDwNEJUntyFqtxzcgwkRPZV/1b0d4ggYvUBMdFmLeRnc6z0ciTl8EpwbTHDAPWixZ0diwntT+Gv4nDlRpsvTg2ily2afFyLB3PhsI0oV841RhgJczE/bEwrc+OqC8kiZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_gz_ph.png
// module id = S3Er
// module chunks = 19